import { checkReservationExists, checkWorker, getReservationsByTask } from "../../ActionUtils";
import { ErrorCode, ErrorSeverity } from "~/modules/error";
import { getLogger, LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { CbmImpl } from "~/modules/cbm";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { sendWorkerTrackingEvent } from "~/modules/telemetry/utils";
import { EVENTS } from "~/modules/telemetry/Analytics";
import { AnalyticsImpl } from "~/modules/telemetry/AnalyticsImpl";
import { Action, TaskReservation } from "~/modules/actions/Action";
import { createFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";





























export class WrapUpTask implements Action<Promise<TaskReservation>> {
    


    readonly #taskSid: string;

    constructor(taskSid: string) {
        this.#taskSid = taskSid;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.retrieveInstanceOf(ContextInstance.TaskRouter, TaskRouterImpl);
        await taskRouter.init();
        const logger = getLogger(context)(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.retrieveInstanceOf(ContextInstance.AnalyticsImpl, AnalyticsImpl);
        const cbm = context.retrieveInstanceOf(ContextInstance.CbmImpl, CbmImpl);
        await cbm.init();

        logger.debug(`wrapUpTask invoked with taskSid: ${this.#taskSid}`);

        checkWorker(worker, {
            actionName: "WrapUpTask",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.WrapUpTaskCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");

        checkReservationExists(reservation, this.#taskSid, {
            actionName: "WrapUpTask",
            moduleName: "actions/Task",
            analytics,
            context,
            worker,
            logger,
            event: EVENTS.WrapUpTaskCompleted,
            extra: {
                taskSid: this.#taskSid
            }
        });

        const validReservation = reservation!;

        try {
            const resultReservation = await cbm.wrapReservation(validReservation);

            sendWorkerTrackingEvent(EVENTS.WrapUpTaskCompleted, analytics, worker, {
                taskSid: this.#taskSid,
                reservationSid: resultReservation.sid
            });

            return { task: resultReservation.task, reservation: resultReservation };
        } catch (error) {
            const errorMsg = `WrapUpTask: Failed to wrap-up reservation ${validReservation.sid} with task ${
                this.#taskSid
            }`;
            logger.error(errorMsg, error);
            sendWorkerTrackingEvent(EVENTS.WrapUpTaskCompleted, analytics, worker, {
                error: errorMsg,
                taskSid: this.#taskSid,
                reservationSid: validReservation.sid
            });
            return Promise.reject(
                createFlexSdkError(context)(
                    ErrorCode.FailedToWrapUpReservation,
                    { severity: ErrorSeverity.Error },
                    errorMsg,
                    error
                )
            );
        }
    }
}
